/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InterviewProfileDto,
    InterviewProfileDtoFromJSON,
    InterviewProfileDtoFromJSONTyped,
    InterviewProfileDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface InterviewProfileDtoPaginatedResultDto
 */
export interface InterviewProfileDtoPaginatedResultDto {
    /**
     * 
     * @type {number}
     * @memberof InterviewProfileDtoPaginatedResultDto
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof InterviewProfileDtoPaginatedResultDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof InterviewProfileDtoPaginatedResultDto
     */
    total?: number;
    /**
     * 
     * @type {Array<InterviewProfileDto>}
     * @memberof InterviewProfileDtoPaginatedResultDto
     */
    results?: Array<InterviewProfileDto> | null;
}

export function InterviewProfileDtoPaginatedResultDtoFromJSON(json: any): InterviewProfileDtoPaginatedResultDto {
    return InterviewProfileDtoPaginatedResultDtoFromJSONTyped(json, false);
}

export function InterviewProfileDtoPaginatedResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterviewProfileDtoPaginatedResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'take': !exists(json, 'take') ? undefined : json['take'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(InterviewProfileDtoFromJSON)),
    };
}

export function InterviewProfileDtoPaginatedResultDtoToJSON(value?: InterviewProfileDtoPaginatedResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'take': value.take,
        'page': value.page,
        'total': value.total,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(InterviewProfileDtoToJSON)),
    };
}


